// api.js
import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://en.icqqg.com', // 你的 API 基础 URL
  withCredentials: false, // 跨域请求时是否需要凭证
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  getProducts() {
    return apiClient.get('/networkCardList'); // 假设你的商品列表接口是 /api/products
  },
  getProductDetail(id) {
    return apiClient.get(`/networkCardDetail/${id}`); // 假设你的商品详情接口是 /api/products/:id
  },
  addFormSubmit(data) {
    return apiClient.get('/addFormSubmit', { params: data }); // 改为 GET 请求，并将数据作为查询参数
  },

  getSetting() {
    return apiClient.get('/getSetting'); // 改为 GET 请求，并将数据作为查询参数
  },

  offers(data) {
    return apiClient.get('/offers', { params: data }); // 改为 GET 请求，并将数据作为查询参数
  }
};
